@if (showRemainingDays) {
  <span class="whitespace-nowrap text-base font-semibold text-default">
    {{
      remainingDays > 1
        ? ('[daysLeft] days left' | translate | translationParams: { daysLeft: remainingDays })
        : ('Ends today' | translate)
    }}
  </span>
}
<!-- originator is used for tracking the origin of the user's action to the plan wizard -->
<button sb-button [color]="'primaryAlt'" (click)="openPlanWizard()">
  {{ buttonText }}
</button>
